import { render, staticRenderFns } from "./SalesChart.pug?vue&type=template&id=64c6e6f8&scoped=true&lang=pug&"
import script from "./SalesChart.vue?vue&type=script&lang=js&"
export * from "./SalesChart.vue?vue&type=script&lang=js&"
import style0 from "./SalesChart.scss?vue&type=style&index=0&id=64c6e6f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c6e6f8",
  null
  
)

export default component.exports